/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DatepickerLanguages extends NgbDatepickerI18n {

    getWeekdayLabel(weekday: number): string { return CoreI18nConfigs.datepickerLanguages.it.weekdays[weekday - 1]; }
    getMonthShortName(month: number): string { return CoreI18nConfigs.datepickerLanguages.it.monthsShort[month - 1]; }
    getMonthFullName(month: number): string { return CoreI18nConfigs.datepickerLanguages.it.monthsFull[month - 1]; }
    getDayAriaLabel(date: NgbDateStruct): string { return `${date.day}/${date.month}/${date.year}`; }

}
